<template>
  <layout :tenantId="tenantId">

    <main id="InfoSection" :aria-label="t('AccessibilityPage')[0].heading">
      <localizedInfoSection sectionName="AccessibilityPage" />
    </main>
    
  </layout>
</template>

<script src="./accessibility.ts"></script>
<style src="./sign2.css"/>
